import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import SensorTile from './SensorTile/SensorTile';
import Grid from './styles/Grid';
import SensorListItem from './SensorListItem/SensorListItem';

function SensorsView({ sensors, view }) {
  if (sensors.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Сенсоры не выбраны
      </Typography>
    );
  }

  if (view === 'grid') {
    return (
      <Grid>
        {sensors.map((sensor) => (
          <SensorTile key={sensor.sensorTypeId} sensor={sensor} />
        ))}
      </Grid>
    );
  }

  return (
    <Box>
      {sensors.map((sensor) => (
        <SensorListItem key={sensor.sensorTypeId} sensor={sensor} />
      ))}
    </Box>
  );
}

SensorsView.propTypes = {
  view: PropTypes.oneOf(['list', 'grid']).isRequired,
  sensors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default SensorsView;
